import script from "./BaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=5b25dfde&lang=scss&scoped=true"
script.__scopeId = "data-v-5b25dfde"

export default script